import { toast } from "sonner";
import { api } from "@/lib/api";

// Admin-settable status values — server enforces this exact set via Enum validation.
export const ADMIN_STATUS_OPTIONS = [
    { value: "pending", label: "Pending" },
    { value: "confirmed", label: "Confirmed" },
    { value: "rescheduled", label: "Rescheduled" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
];

const EMAIL_STATUSES = new Set(["confirmed", "completed", "cancelled", "rescheduled"]);

export default function StatusDropdown({ booking, onChanged }) {
    async function handleChange(e) {
        const newStatus = e.target.value;
        if (newStatus === booking.status) return;
        try {
            await api.patch(`/admin/bookings/${booking.id}`, { status: newStatus });
            const willEmail = EMAIL_STATUSES.has(newStatus);
            toast.success(willEmail ? "Status updated · client emailed" : "Status updated");
            onChanged?.();
        } catch (err) {
            const msg = err?.response?.data?.detail || "Could not update status";
            toast.error(typeof msg === "string" ? msg : JSON.stringify(msg));
        }
    }

    // Show current value even if it's a system-set status (received / pending_payment / quote_requested).
    const isSystemSet = !ADMIN_STATUS_OPTIONS.some((o) => o.value === booking.status);

    return (
        <select
            value={booking.status}
            onChange={handleChange}
            className="h-8 rounded-full border border-[#ECE4D3] bg-white px-2 text-xs font-medium"
            data-testid={`status-select-${booking.reference_id}`}
        >
            {isSystemSet && (
                <option value={booking.status} disabled>
                    {(booking.status || "").replaceAll("_", " ")}
                </option>
            )}
            {ADMIN_STATUS_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                    {o.label}
                </option>
            ))}
        </select>
    );
}
